var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrayOneIsometric(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 521.16 389.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#207d8c;}.cls-2{fill:#b5b5b6;}.cls-3{fill:#fff;}.cls-4{fill:#474748;}.cls-5{fill:#3d3d3d;}.cls-6{fill:#9b9a9a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M519.39,229.42C517.13,227.06,318.89,21,311,12.64c-8.55-9-19.88-4.85-20.09-4.77.1,0,.66-.26-9.53,2.65C270.54,13.61,267,9.73,267,9.73s-4-5.24-17.63-1.29C233.58,13,7.86,70.37,7.86,70.37S.77,72.19.69,79.46,0,124.22,0,124.22,195.25,375.59,202.91,385.55c6.27,8.2,22,2.49,22,2.49s284.08-103,290.7-105.41C521.45,280.15,521,275,521,275l.13-37.91S521.36,231.53,519.39,229.42Zm-98.15-57.16-184,60.7a10.86,10.86,0,0,1-11-3.26l-91-113.52c-2.41-3-1.34-6.31,2.36-7.35l177-49.59a12.76,12.76,0,0,1,11.55,3.2L423.08,165C425.72,167.78,424.9,171.06,421.24,172.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M482.58,185.58c-1.89-2-167.09-173.72-173.71-180.65-7.11-7.46-16.56-4-16.74-4,.08,0,.55-.23-7.94,2.2-9,2.58-11.91-.66-11.91-.66S269-1.86,257.59,1.43C244.4,5.24,56.3,53,56.3,53s-5.91,1.52-6,7.57-.58,37.3-.58,37.3S212.46,307.39,218.84,315.69c5.23,6.83,18.36,2.08,18.36,2.08S473.94,232,479.45,229.92c4.84-2.07,4.5-6.38,4.5-6.38l.1-31.59S484.22,187.34,482.58,185.58Zm-61.34-13.32-184,60.7a10.86,10.86,0,0,1-11-3.26l-91-113.52c-2.41-3-1.34-6.31,2.36-7.35l177-49.59a12.76,12.76,0,0,1,11.55,3.2L423.08,165C425.72,167.78,424.9,171.06,421.24,172.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M480,182.73S315.49,11.75,308.87,4.81c-7.11-7.46-16.56-4-16.74-4,.08,0,.55-.22-7.94,2.21-9,2.57-11.91-.66-11.91-.66S269-2,257.59,1.31C244.4,5.12,56.3,52.93,56.3,52.93s-8.71,3-3.6,9.42C58.07,69.4,101.3,126,101.3,126S208.81,261.24,216.85,271.29,240,275.17,240,275.17s227.06-77.39,237.78-81S480,182.73,480,182.73Zm-58.72-10.47-184,60.7a10.86,10.86,0,0,1-11-3.26l-91-113.52c-2.41-3-1.34-6.31,2.36-7.35l177-49.59a12.76,12.76,0,0,1,11.55,3.2L423.08,165C425.72,167.78,424.9,171.06,421.24,172.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "241.66 281.15 241.66 308.67 474.47 224.48 474.47 201.17 241.66 281.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "474.47 201.17 458.13 206.84 474.47 224.48 474.47 201.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M112,128.13l-7.76,1.57c17.27,21.72,105.36,132.53,112.61,141.59A15.61,15.61,0,0,0,228.6,277Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M480,182.73S409.43,109.41,358.89,56.84l-4.08,1.74L482.22,191.4C485.25,187.58,480,182.73,480,182.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M116.54,58.53c-8.47,2.19-26.72,8.67-16.64,21.56s24.94,13.26,42.42,8.43,132.73-36.46,143.9-39.6,25.7-9.77,12.89-21.8-30.41-8.71-44.76-4.92S125,56.33,116.54,58.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M317,13.22l-2-2L289.9,17.92a31.13,31.13,0,0,1,3.67,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M92.33,70.72,64.64,78.07l1.92,2.51,25.8-6.91A9.15,9.15,0,0,1,92.33,70.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M321.16,17.6l-2-2-22.27,6a28.92,28.92,0,0,1,2.44,1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M68.15,82.62l1.93,2.5,24.23-6.47A17.48,17.48,0,0,1,93,76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M303.49,27.77l21.75-5.92-1.94-2-21.6,5.86c.32.33.63.67.94,1S303.22,27.42,303.49,27.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M96.13,81.29,72.06,87.8,74,90.29,98.14,83.7c-.48-.53-1-1.08-1.42-1.65C96.5,81.79,96.32,81.54,96.13,81.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M75.78,92.56l1.94,2.49,25.17-6.89c-.87-.69-1.73-1.44-2.59-2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M329.33,26.1l-1.94-2-22.24,6.05a15.89,15.89,0,0,1,1.18,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M79,96.8l2,2.48,27.69-7.54a30.71,30.71,0,0,1-3.51-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M307.13,37.37l26.16-7.16-1.93-2-24.31,6.61A8.81,8.81,0,0,1,307.13,37.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M429.19,165.28,329.58,59.9a16.45,16.45,0,0,0-14.85-4.11l-183.54,51.5c-4.76,1.34-6.12,5.59-3,9.44l94.32,117.15a14,14,0,0,0,14.19,4.17l190.15-63.39C431.53,173.1,432.59,168.87,429.19,165.28Zm-7.95,7-184,60.7a10.86,10.86,0,0,1-11-3.26l-91-113.52c-2.41-3-1.34-6.31,2.36-7.35l177-49.59a12.76,12.76,0,0,1,11.55,3.2L423.08,165C425.72,167.78,424.9,171.06,421.24,172.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M330,217.59c-3.12-1.08-3.11-2.79,0-3.82l22.32-7.3c3.13-1,5.27.8,4.74,4.06l-1.55,9.58a4.9,4.9,0,0,1-6.63,4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayOneIsometric);
export default __webpack_public_path__ + "static/media/gray-one-isometric.99104673d30cd117d9fb8a576ac355d9.svg";
export { ForwardRef as ReactComponent };